import { useNavigate } from 'react-router-dom';
import { COMPANY } from '../data/content';

export default function Footer() {
  const navigate = useNavigate();
  const goTo = (p) => { navigate(p); window.scrollTo(0, 0); };

  return (
    <footer data-testid="footer" style={{ background: '#1C1917', color: '#fff' }}>

      {/* ── CTA band ── */}
      <div style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-14 md:py-16 text-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] mb-3" style={{ color: '#6B7280' }}>
            Ready to improve your yarn quality?
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight mb-7">
            Every measurement matters
          </h2>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              data-testid="footer-whatsapp-cta"
              href={COMPANY.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-safety text-white font-heading uppercase text-sm tracking-wider px-8 py-3.5 hover:-translate-y-0.5 hover:bg-orange-600 transition-all duration-200 inline-block"
            >
              Get a Quote on WhatsApp
            </a>
            <a
              data-testid="footer-call-cta"
              href={`tel:${COMPANY.phoneRaw}`}
              className="font-heading uppercase text-sm tracking-wider px-8 py-3.5 hover:-translate-y-0.5 transition-all duration-200 inline-block"
              style={{ border: '1px solid rgba(255,255,255,0.2)', color: 'rgba(255,255,255,0.65)' }}
            >
              Call Us
            </a>
          </div>
        </div>
      </div>

      {/* ── Footer body ── */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-14">

        {/* Brand + nav grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 mb-12">

          {/* Brand — 2 of 3 cols */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center border-2 border-white">
                <span className="font-heading font-bold text-sm text-white">A</span>
              </div>
              <span className="font-heading font-semibold text-base tracking-wide uppercase text-white">
                Apex Precitech
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-sm mb-3" style={{ color: '#9CA3AF' }}>
              Precision instruments for textile spinning machinery since 1996.
              Trusted by 5,000+ mills across 18+ countries.
            </p>
            <p className="font-mono text-[10px] uppercase tracking-wider" style={{ color: '#6B7280' }}>
              {COMPANY.address}
            </p>
          </div>

          {/* Navigate — 1 of 3 cols */}
          <div>
            <h4 className="font-heading text-xs uppercase tracking-wider mb-4" style={{ color: '#6B7280' }}>
              Navigate
            </h4>
            <div className="space-y-2.5">
              {[
                ['Home',      '/'],
                ['Products',  '/products'],
                ['About',     '/about'],
                ['Knowledge', '/knowledge'],
              ].map(([label, path]) => (
                <button
                  key={path}
                  onClick={() => goTo(path)}
                  className="block text-sm transition-colors hover:text-white text-left"
                  style={{ color: '#9CA3AF' }}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-4"
          style={{ borderTop: '1px solid rgba(255,255,255,0.07)' }}
        >
          <p className="font-mono text-[10px] uppercase tracking-wider" style={{ color: '#4B5563' }}>
            &copy; {new Date().getFullYear()} Apex Precitech. All rights reserved.
          </p>
          <p className="font-mono text-[10px]" style={{ color: '#4B5563' }}>
            Precision since 1996
          </p>
        </div>

      </div>
    </footer>
  );
}
